webpackJsonp([51291600833128],{

/***/ 609:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _LoreHookReducers = __webpack_require__(63);
	
	var _LoreHookReducers2 = _interopRequireDefault(_LoreHookReducers);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _LoreHookReducers2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'nextState'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Change what gets returned from the Redux store.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This method is intended ONLY as a way to explore different solutions for addressing immutability concerns that arise when components have a direct reference to the data kept in the reducers.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default behavior in Redux is to provide components with a reference to the store state returned from the reducers. This poses a problem when a component tries to change that data, because it will modify the state of the store through that reference.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'To address this issue, the top-level reducer will invoke this method right before returning the next state, which gives you the ability to experiment with different solutions for this problem.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default behavior is to return a copy of the store state, which will prevent any component from being able to modify the "truth" kept in the reducers.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Others solutions could be invoking ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Object.freeze(nextState)'
	      ),
	      ' (which will throw an error if a component tries to modify the store state) or converting the store state to an Immutable object using ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'Immutable.map(nextState)'
	      ),
	      ' from Immutable.js.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      nextState: function(nextState) {\n        return _.cloneDeep(nextState);\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-hooks-lore-hook-reducers-config-next-state-js-18859ee9eab23052e910.js